
const isProduction = process.env.NODE_ENV === 'production';

const getDomain = () =>{
  let hostName = document.location.hostname;
  const HostName = hostName.replace('www.','');
  return HostName
}

const getProtocolStr = () =>{
  const ProtocolStr = document.location.protocol;
  return ProtocolStr
}

const getEndpoint = () => {
  if (isProduction) {
    return PRODUCT_ENDPOINT_SET;
  }

  return DEFAULT_ENDPOINT_SET;
};

const DEFAULT_ENDPOINT_SET = {
  domain:'rollingbet.info',
  api:getProtocolStr()+'//api.rollingbet.info/',
  file:getProtocolStr()+'//file.rollingbet.info'
};

const PRODUCT_ENDPOINT_SET = {
  domain:getDomain(),
  api: getProtocolStr()+'//api.'+getDomain()+'/',
  file:getProtocolStr()+'//file.'+getDomain()
};

export const BACKEND_LOCATION = getEndpoint();

export default {
  BACKEND_LOCATION,
};
